import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { autoUploadPromo } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import { preOverquotaBanner } from 'reactApp/appHelpers/featuresHelpers/features/overquotaPre';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { PromoBlock } from 'reactApp/ui/Mobile/PromoBlock/PromoBlock';
import { PromoBlockData } from 'reactApp/ui/Mobile/PromoBlock/PromoBlock.data';
import type { PromoBlockBase } from 'reactApp/ui/Mobile/PromoBlock/PromoBlock.types';

import { usePreOverquoterBlock } from './usePreOverquoterBlock';

interface ShowData {
    onShow(): void;
    onClick(): void;
    onSecondaryClick?(): void;
    onClose?(): void;
    doNotClose?: boolean;
}

export const usePromoBlock = () => {
    const dispatch = useDispatch();
    const [showData, setShowData] = useState<null | undefined | ShowData>(null);

    const autoUploadPromoData = useSelector(PromoSelectors.pullPromo(EPromoType.autoUpload));

    const { showPreOverquoter, preOverquotaPromoProps, preOverquotaPromoData } = usePreOverquoterBlock();

    const showBlock = (autoUploadPromo && autoUploadPromoData) || (preOverquotaBanner && showPreOverquoter);

    let promoData: ShowData | null = null;
    let promoBlockProps: PromoBlockBase | null = null;
    if (showPreOverquoter) {
        promoData = preOverquotaPromoData;
        promoBlockProps = preOverquotaPromoProps;
    }
    if (!promoData && autoUploadPromoData) {
        promoData = autoUploadPromoData;
        promoBlockProps = PromoBlockData.AUTOUPLOAD_PROMO_BLOCK;
    }

    const handleClick = useCallback(() => {
        showData?.onClick();
        if (!showData?.doNotClose) {
            setShowData(null);
        }
    }, [dispatch, showData]);

    const handleSecondaryClick = useCallback(() => {
        showData?.onSecondaryClick?.();
        if (!showData?.doNotClose) {
            setShowData(null);
        }
    }, [dispatch, showData]);

    const handleShow = useCallback(() => {
        showData?.onShow();
    }, [showData]);

    const handleClose = useCallback(() => {
        showData?.onClose?.();
        setShowData(null);
    }, [showData]);

    useEffect(() => {
        if (!showBlock) {
            return;
        }

        setShowData(promoData);
    }, [showBlock]);

    if (!showData || !promoBlockProps) {
        return null;
    }

    return (
        <PromoBlock
            {...promoBlockProps}
            onClick={handleClick}
            onClose={handleClose}
            onShow={handleShow}
            onSecondaryClick={handleSecondaryClick}
            showOnce={false}
        />
    );
};
